import React from "react";

// Small status pill for a policy version (approved | draft | superseded).
export default function VersionBadge({ version, status = "approved" }) {
  const tone =
    status === "approved"
      ? "bg-emerald-100 text-emerald-800"
      : status === "superseded"
      ? "bg-slate-100 text-slate-600"
      : "bg-amber-100 text-amber-800";
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${tone}`}
      data-testid="version-badge"
    >
      v{version} · {status}
    </span>
  );
}
